import React, { useState, useEffect, useContext, useRef } from 'react';

import { SaleListContext } from '../../SaleListContext';


export function SaleListSearchInput() {

  const {
    isLoading, setIsFirstLoad,
    searchWord, setSearchWord,
    searchTypeList,
  } = useContext(SaleListContext);

  const inputRef = useRef<HTMLInputElement>(null);
  const inputWordRef = useRef<string>('');
  const [inputWord, setInputWord] = useState<string>(searchWord || '');
  // 日本語入力で２回入力判定になることの防止
  const [isComposing, setIsComposing] = useState(false);


  // フォーカスでの入力補助表示
  const onFocus = () => {
  }


  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if(!isLoading) {
      const val = e.target.value;
      setInputWord(val);
      inputWordRef.current = val;
    }
  }

  // 検索開始
  const startSearch = () => {
    if(!isLoading) {
      const keyword = inputWordRef.current;
      setSearchWord(keyword);
      inputRef.current?.blur();
      // 初回読み込み
      setTimeout(() => {
        setIsFirstLoad(false);
      }, 100)
    }
  }

  // キーボードの改行
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // PC・スマホ共通
      if (e.key === "Enter") {
        // 日本語入力で２回入力判定になることの防止
        if (isComposing) return;
        e.preventDefault();
        // キーボードを閉じる
        inputRef?.current?.blur();
        // 検索開始
        startSearch();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isComposing]);


  // 検索ラベルが変更になったら入力を空に
  useEffect(() => {
    setSearchWord('');
    setInputWord('');
  }, [searchTypeList])


  return (
    <div className="input-group">
      <input
        ref={inputRef}
        type="text"
        className="form-control"
        style={{fontSize: '16px'}}
        placeholder="例) 文法 / リスニング / 発音"
        value={inputWord}
        onChange={onInputChange}
        onFocus={onFocus}
        onCompositionStart={() => setIsComposing(true)}  // ← IME開始
        onCompositionEnd={() => setIsComposing(false)}   // ← IME確定完了
      />
      <span className="input-group-addon" onClick={startSearch}>
        <span className="glyphicon glyphicon-search" aria-hidden="true"></span>
      </span>
    </div>
  );
}